///borrowed from here: https://stackoverflow.com/questions/40664523/angular2-ngbdatepicker-how-to-format-date-in-inputfield
import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct, NgbDateAdapter } from "@ng-bootstrap/ng-bootstrap";
import { DateTime } from "luxon";

function padNumber(value: number) {
	if (isNumber(value)) {
		return `0${value}`.slice(-2);
	} else {
		return "";
	}
}

function isNumber(value: any): boolean {
	return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
	return parseInt(value);
}
function makeYear(value: any): number {
	var val = toInteger(value);
	if (val < 1000) {
		val += 2000;
	} else if (val < 2000) {
		val += 1000;
	}
	return val;
}


@Injectable()
export class ECINgbDateParserFormatter extends NgbDateParserFormatter {
	parse(value: string): NgbDateStruct {
		if (value) {
			const dateParts = value.trim().split('/');
			if (dateParts.length === 1 && isNumber(dateParts[0])) {
				switch (dateParts[0].length) {
					case 8:
						return { year: makeYear(dateParts[0].substr(4, 4)), month: toInteger(dateParts[0].substr(0, 2)), day: toInteger(dateParts[0].substr(2, 2)) };
					case 7:
						return { year: makeYear(dateParts[0].substr(3, 4)), month: toInteger(dateParts[0].substr(0, 1)), day: toInteger(dateParts[0].substr(1, 2)) };
					case 6:
						return { year: makeYear(dateParts[0].substr(4, 2)), month: toInteger(dateParts[0].substr(0, 2)), day: toInteger(dateParts[0].substr(2, 2)) };
					default:
						return { year: makeYear(dateParts[0]), month: null, day: null };
				}

			} else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
				return { year: makeYear(dateParts[1]), month: toInteger(dateParts[0]), day: null };
			} else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
				return { year: makeYear(dateParts[2]), month: toInteger(dateParts[0]), day: toInteger(dateParts[1]) };
			}
		}
		return null;
	}

	format(date: NgbDateStruct): string {
		let stringDate: string = "";
		if (date) {
			stringDate += isNumber(date.month) ? padNumber(date.month) + "/" : "";
			stringDate += isNumber(date.day) ? padNumber(date.day) + "/" : "";
			stringDate += date.year;
		}
		return stringDate;
	}
}


@Injectable()
export class NgbDateNativeAdapter extends NgbDateAdapter<Date> {
	fromModel(date: Date): NgbDateStruct {
		return date ? { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() || 1 } : null;
	}

	toModel(date: NgbDateStruct): Date {
		return date ? new Date(date.year, date.month - 1, date.day, 0, 0, 0) : null;
	}
}

@Injectable()
export class NgbDateStringAdapter extends NgbDateAdapter<string> {
	fromModel(value: string): NgbDateStruct {
		if (value) {
			let newDate: Date = new Date(value);
			var dt = DateTime.fromJSDate(newDate);
			if (typeof(value) == 'string' && value.endsWith('Z')) {
				dt = dt.toUTC();
			}

			return newDate ? { year: dt.year, month: dt.month, day: dt.day } : null;
		}
		return null;
	}

	toModel(date: NgbDateStruct): string {
		let stringDate: string = "";
		if (date) {
			var lxDate = DateTime.local(date.year, date.month, date.day);
			stringDate = lxDate.toJSON();
		}
		return stringDate;
	}
}
